import { createApiSlice } from 'app/createApiSlice'
import { API_USER_ITEM_PRICES } from 'utils/apiList'

export const priceTableApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'priceTable/api',
  endpoints(builder) {
    return {
      // GET: Fetch all price tables with pagination and search
      fetchPriceTables: builder.query({
        query({
          page = 0,
          size = 20,
          sortby = 'createdAt',
          sortdir = 'DESC',
          itemId,
          unit,
        }) {
          return {
            url: `/${API_USER_ITEM_PRICES}`,
            params: {
              page,
              size,
              sortby,
              sortdir,
              ...(itemId ? { itemId } : {}),
              ...(unit ? { unit } : {}),
            },
          }
        },
      }),

      // GET: Fetch single price table by ID
      getPriceTableById: builder.query({
        query(id) {
          return {
            url: `/${API_USER_ITEM_PRICES}/${id}`,
            method: 'GET',
          }
        },
      }),

      // POST: Create new price table
      createPriceTable: builder.mutation({
        query(payload) {
          return {
            url: `/${API_USER_ITEM_PRICES}`,
            method: 'POST',
            body: payload,
          }
        },
      }),

      // PUT: Update price table
      updatePriceTable: builder.mutation({
        query({ id, ...payload }) {
          return {
            url: `/${API_USER_ITEM_PRICES}/${id}`,
            method: 'PUT',
            body: payload,
          }
        },
      }),

      // DELETE: Soft delete price table
      deletePriceTable: builder.mutation({
        query(id) {
          return {
            url: `/${API_USER_ITEM_PRICES}/${id}`,
            method: 'DELETE',
          }
        },
      }),
    }
  },
})

export const {
  useFetchPriceTablesQuery,
  useLazyFetchPriceTablesQuery,
  useGetPriceTableByIdQuery,
  useLazyGetPriceTableByIdQuery,
  useCreatePriceTableMutation,
  useUpdatePriceTableMutation,
  useDeletePriceTableMutation,
} = priceTableApiSlice
